jQuery(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  function toNumericPrice(value) {
    var normalized = String(value == null ? "" : value)
      .replace(/[^\d.,-]/g, "")
      .replace(/,/g, "")
      .trim();
    var number = Number(normalized);
    return Number.isFinite(number) ? number : 0;
  }

  function getLastWordFromURL() {
    var url = window.location.href;
    var parts = url.split("/");
    var lastPart = parts[parts.length - 1] || parts[parts.length - 2]; // Handle trailing slash
    return lastPart;
  }

  var page = __st.p;

  if (page == "product") {
    var prod_id = __st.rid;
    // .trim() is load-bearing. sections/main-product.liquid renders the title on
    // its own indented line inside <h1 class="title">, so .text() returns it
    // wrapped in the template's whitespace. product_name is the join key between
    // "Viewed Product" and the spotlight events (spec section 3) and must be
    // Shopify's title exactly — padded, it matches nothing on the PLP, where the
    // value comes off data-product as product.title.
    var prod_title = jQuery(".product-form .title-row .title").text().trim();
    var productHandle = jQuery(".product-form .title-row .title").data("product-handle");
    let productType = jQuery(".product-form").data("product-type") || "";
    let productOccasion = jQuery(".product-form .title-row .title").data("occasion")
    var imageUrl = jQuery(".product-form .title-row .title").data("image-url");
    // On a discounted product .current-price wraps BOTH prices
    // (sections/main-product.liquid:728): .ct_compare holds the CURRENT price
    // despite its name, .ct_main_price holds the compare-at. Reading the
    // wrapper's .text() glued the two together and .replace("₹ ", "") stripped
    // only the first symbol, so product_price went out as "1,234.00 ₹ 2,000.00".
    // Take the inner current-price node when it is there, the wrapper otherwise.
    var priceEl = jQuery(".price-container .current-price");
    var priceNode = priceEl.find(".ct_compare").first();
    var price = priceNode.length ? priceNode.text() : priceEl.text();
    // Strip currency text, remove Indian thousands separators, and send the
    // price to CleverTap as a decimal number (for example, 1234.50).
    var amountText = price.replace(/[^\d.,]/g, "").replace(/,/g, "").trim();
    var amount = Number(amountText);

    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");

      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";

      var source = "Direct";
    }
    var prod_sku=jQuery("[name='id'] option:selected").attr("data-sku");

    clevertap.event.push("Viewed Product", {
      // Appended, never a rename — live campaigns are bound to this event.
      // Set at click time on the surface the customer came from and read once;
      // see window.kPlpEntryPoint in the PLP ANALYTICS block at the end of this
      // file. Blank on a direct or deep-linked PDP, which is the honest answer.
      entry_point: window.kPlpEntryPoint ? window.kPlpEntryPoint() : "",
      user_source: source,
      sku: prod_sku,
      product_name: prod_title,
      product_category: "",
      product_url: productHandle,
      product_image: imageUrl,
      product_price: amount,
      product_occasion: productOccasion,
      product_type: productType,
      utm_campaign: utm_campaign,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "collection") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
  } else if (page == "home") {
    var utm_source = getUrlParameter("utm_source");
    if (utm_source != false) {
      var utm_medium = getUrlParameter("utm_medium");
      var utm_campaign = getUrlParameter("utm_campaign");
      var source_page = "social";
      var source = "Social";
    } else {
      var utm_source = "";
      var utm_medium = "";
      var utm_campaign = "";
      var source_page = "";
      var source = "Direct";
    }
    var collection_title = jQuery(
      ".container  .overlay-text__inner .overlay-text__title"
    ).text();
    var collection_url = window.location.href;
    if (__st.cid != undefined) {
      var user_id = __st.cid;
    } else {
      var user_id = "";
    }
    var d = new Date();
    clevertap.event.push("ViewedHomepage", {
      source: source,
      timestamp: d,
      user_id: user_id,
      utm_campaign: utm_source,
      utm_medium: utm_medium,
      utm_source: utm_source,
    });
  } else if (page == "page") {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  } else {
    var lastWord = getLastWordFromURL();
    page = lastWord;
  }
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Recently Viewd Product Clicked *********/
  document.addEventListener('click', function (e) {
    let recentItem = e.target.closest('.ct-recently-viewed li');
    if (!recentItem) return;

    let recentProduct = recentItem.querySelector('.CT_product-block');
    if (!recentProduct) return;

    let title = recentProduct.getAttribute('data-product') ||
      (recentProduct.querySelector('.product-link') || {}).textContent;
    if (!title) return;

    clevertap.event.push("Clicked Recently Viewed", {
      "Product name": title.trim(),
      "Page Name": page,
    });
  });

  /******* Shop By Collection product clicked *********/
  document.addEventListener('click', function (e) {
    var productCard = e.target.closest('.explpre-collections-container .CT_product-block');
    if (!productCard || !window.clevertap || !clevertap.event) return;

    // Wishlist/utility controls are not product clicks.
    if (e.target.closest('.wishlist_img_main, button, .card-carousel-dots')) return;

    var activeCollection = document.querySelector(
      '.explpre-collections-container .collection-tag-pdp.is-active'
    );
    var collectionTag = activeCollection
      ? '#' + activeCollection.textContent.trim().replace(/^#/, '')
      : '';

    clevertap.event.push('Shop by collection Product Click', {
      entry_point: 'shop_by_collection',
      user_source: source || '',
      sku: productCard.getAttribute('data-sku') || '',
      product_name: productCard.getAttribute('data-product') || '',
      product_category: '',
      product_url: productCard.getAttribute('data-prodURL') || '',
      product_image: productCard.getAttribute('data-imageUrl') || '',
      product_price: Number(String(productCard.getAttribute('data-prodPrice') || '').replace(/[^\d.-]/g, '')) || 0,
      product_occasion: productCard.getAttribute('data-prodOccation') || '',
      product_type: productCard.getAttribute('data-product-type') || '',
      collection_tag: collectionTag,
      utm_campaign: utm_campaign || '',
      utm_medium: utm_medium || '',
      utm_source: utm_source || ''
    });
  });
  /******* User Account icon  Clicked *********/
  jQuery(document).on('click', '.opposing-items button', function () {
    clevertap.event.push("Login Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on('click', '.ct_log_out', function () {
    clevertap.event.push("Logout Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".header-account-link", function () {
    clevertap.event.push("Account Icon Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box.order-box-0", function () {
    clevertap.event.push("Profile Viewed", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-orders", function () {
    clevertap.event.push("Orders Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-contact-us", function () {
    clevertap.event.push("Contact Us Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-stores", function () {
    clevertap.event.push("Stores Clicked", {
      interaction_type: page,
    });
  });

  jQuery(document).on("click", ".order-box-addresses", function () {
    clevertap.event.push("Address Clicked", {
      interaction_type: page,
    });
  });


  /******* User Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".header_hhrt", function () {
    clevertap.event.push("Clicked Wishlist Icon", {
      "page name": page,
    });
  });

  /******* Home page Banner Clicks *********/
  jQuery(document).on("click", '.imagegrid-box', function () {
    let index = jQuery(this).attr('data-index');
    let title = jQuery(this).attr('data-title');
    let subtitle = jQuery(this).attr('data-subtitle');
    const toApp = {
      index: index,
      title: title,
      subtitle: subtitle
    };

    if (window.KushalsNativeCleverTap) {
      KushalsNativeCleverTap.pushEvent("Home Page Banner Click", JSON.stringify(toApp));
    } else {
      clevertap.event.push("Home Page Banner Click", {
        "index": index,
        "title": title,
        "subtitle": subtitle
      });
    }
  });

  jQuery(document).on("click", '.homepage-tab-section', function () {
    let index = jQuery(this).attr('data-index');
    let title = jQuery(this).attr('data_page_target_btn');
    let subtitle = jQuery(this).attr('data-subtitle');
    clevertap.event.push("Home Page Tab Click", {
      "index": index,
      "title": title,
      "subtitle": subtitle
    });
  });

  /******* Product Wishlist icon  Clicked *********/
  jQuery(document).on("click", ".zoomywishidheart .zoomycheck", function () {
    var $this = jQuery(this).closest(".zoomywishid");
    var title = $this.attr("data-title");
    var prod_price = toNumericPrice($this.attr("data-price"));
    var prod_id = $this.attr("data-product-id");
    var page_url = __st.pageurl;

    clevertap.event.push("Wishlisted", {
      wishlisted_product_type: "",
      wishlisted_product_name: title,
      wishlisted_product_price: prod_price,
      wishlisted_product_id: prod_id,
      page_url: page_url,
    });
  });
  /******* Click on Begin Checkout button *********/
jQuery(document).on("click", ".ct_snapmint_checkout, .ct_snapmint_order_btn", function (e) {

  let customerCity = "";
  try {
    let locData = localStorage.getItem("location_store");
    if (locData) {
      locData = JSON.parse(locData);
      customerCity = locData.city || "";
    }
  } catch (err) {
    console.error("City fetch error:", err);
  }

  var $firstItem = jQuery('.mm-ajaxcart-item').first();

  if (!$firstItem.length) {
    // no items, just fire basic event
    clevertap.event.push("Begin Checkout");
    return;
  }

  // First product details (unit price)
  var firstProductName     = $firstItem.attr('data-prod-title') || '';
  var firstProductImageUrl = $firstItem.find('.mm-ajaxcart-item-image img').attr('src') || '';
  var firstProductUrl      = $firstItem.find('.mm-ajaxcart-item-name a').attr('href') || '';
  var firstProductPrice    = toNumericPrice($firstItem.attr('data_main_price')); // unit price in INR
  var firstProductCategory = $firstItem.attr('data-prod-type') || '';

  //  Calculate total cart pricec
  let totalCartPrice = 0;

  jQuery('.mm-ajaxcart-item').each(function () {
    var $item = jQuery(this);

    let price = toNumericPrice($item.attr('data_main_price'));   // unit price
    let qty   = parseInt($item.find('.quantity-input').val(), 10) || 1; // quantity

    totalCartPrice += price * qty;
  });

  clevertap.event.push("Begin Checkout", {
    "First Product Name": firstProductName,
    "First Product Image": firstProductImageUrl,
    "First Product URL": firstProductUrl,
    "First Product Price": firstProductPrice,
    "First Product Category": firstProductCategory,
    "Total Cart Price": totalCartPrice,
    "Customer City": customerCity
  });

});

const GIFT_SETTINGS_CACHE_KEY = "gift_settings_cache_v1";

function getGiftSettingsFromCache() {
  try {
    const raw = localStorage.getItem(GIFT_SETTINGS_CACHE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return parsed;
  } catch (e) {
    return null;
  }
}

// Map: variantId -> { tier: "T1|T2|T3", name: "Mini/Medium/Large..." }
function buildGiftVariantMap(giftSettings) {
  const map = new Map();
  if (!giftSettings || typeof giftSettings !== "object") return map;

  // Current API shape: { cartGiftingDTOS: [{ variantId, priceRangeMin, ... }, ...] }
  const dtos = Array.isArray(giftSettings.cartGiftingDTOS) ? giftSettings.cartGiftingDTOS : [];
  if (dtos.length) {
    const tiersSorted = dtos
      .map((d) => ({
        variantId: Number(d.variantId),
        minRupees: Number(d.priceRangeMin),
      }))
      .filter((d) => Number.isFinite(d.variantId) && Number.isFinite(d.minRupees))
      .sort((a, b) => a.minRupees - b.minRupees);

    const tierLabels = ["T1", "T2", "T3"];
    const giftNames = ["Mini Jewelry Box", "Medium Jewelry Box", "Large Jewelry Box"];

    tiersSorted.forEach((t, idx) => {
      const tier = tierLabels[idx] || `T${idx + 1}`;
      const name = giftNames[idx] || "Jewelry Box";
      map.set(String(t.variantId), { tier, name });
    });

    return map;
  }

  // Legacy fallback shape: { T1: { variant_ids: [] }, T2: ... }
  ["T1", "T2", "T3"].forEach((tier) => {
    const tierObj = giftSettings[tier];
    if (!tierObj) return;

    const ids = tierObj.variant_ids || tierObj.variantIds || tierObj.variants || [];
    const displayName =
      tierObj.name ||
      tierObj.title ||
      tierObj.label ||
      (tier === "T1" ? "Mini Jewelry Box" : tier === "T2" ? "Medium Jewelry Box" : "Large Jewelry Box");

    (Array.isArray(ids) ? ids : []).forEach((id) => {
      map.set(String(id), { tier, name: displayName });
    });
  });

  return map;
}

function getCartItemVariantId($item) {
  // adjust if your cart DOM uses a different attribute
  return (
    $item.attr("data-variant_id") ||
    $item.attr("data-variant-id") ||
    $item.attr("data-variant") ||
    $item.find('[name="id"]').val() ||
    ""
  );
}

jQuery(document).on("click", ".ct_snapmint_checkout, .ct_snapmint_order_btn", function (e) {
  // --- your existing Begin Checkout code stays exactly the same above ---

  // NEW: Fire FreeBox_Offer_Applied with ONLY Gift Name + Tier
  const giftSettings = getGiftSettingsFromCache();
  const giftVariantMap = buildGiftVariantMap(giftSettings);

  if (giftVariantMap.size) {
    const found = [];

    jQuery(".mm-ajaxcart-item").each(function () {
      const $item = jQuery(this);
      const vid = String(getCartItemVariantId($item) || "").trim();
      if (!vid) return;

      const meta = giftVariantMap.get(vid);
      if (meta) found.push(meta); // {tier, name}
    });

    if (found.length) {
      const giftName = found[0].name || "";
      const giftTier = found[0].tier || "";
      const payload = {
        Gift_Name: giftName,
        Gift_Tier: giftTier,
      };
      clevertap.event.push("FreeBox_Offer_Applied", payload);
    }
  }
});


  /******* Click Remove button on cart drawer*********/
  jQuery(document).on("click", ".mm-ajaxcart-remove-item", function (e) {
    e.preventDefault();
    let product_data = {
      "product_id": jQuery(this).closest('li').data("prod-id"),
      "product_name": jQuery(this).closest('li').data("prod-title"),
      "product_price": toNumericPrice(jQuery(this).closest('li').attr("data_main_price")),
      "page_url": __st.pageurl,
      "sku": jQuery(this).closest('li').attr("data-sku"),
      "product_quantity": 1,
    };

    clevertap.event.push("RemoveFromCart", product_data);
    return true;
  });

  /******* Jewellery Finder CTA *********/
  // "Jewellery Finder Used" was retired — it duplicated "Jewellery Finder
  // Started", which now carries the same page_name. This CTA is the only place
  // that knows WHERE the customer entered from, so it records that and lets
  // assets/jewellery-find.js report it once the finder opens.
  jQuery(document).on("click", ".jf-cta", function () {
    var pageName = page;
    if (page == "home") {
      pageName = "Homepage";
    } else if (page == "product") {
      pageName = "PDP";
    } else if (page == "collection") {
      pageName = "PLP";
    }
    try {
      sessionStorage.setItem("jf_entry_page", pageName);
    } catch (e) {}
  });

  /******* Gift Finder CTA *********/
  // Mirrors the Jewellery Finder CTA above — separate class/key so the two
  // funnels never share an entry-page value. Read by assets/gift-for-her-find.js.
  jQuery(document).on("click", ".gf-cta", function () {
    var pageName = page;
    if (page == "home") {
      pageName = "Homepage";
    } else if (page == "product") {
      pageName = "PDP";
    } else if (page == "collection") {
      pageName = "PLP";
    }
    try {
      sessionStorage.setItem("gf_entry_page", pageName);
    } catch (e) {}
  });

  /******* Click on Banner *********/
  jQuery(document).on(
    "click",
    ".mm-ajaxcart-remove-item.slick-current.slick-active a",
    function () {
      // clevertap.event.push("BannerClicked", {
      //                   "BannerID":
      //                   "BannerPosition":
      //                   "DestinationPageURL":
      //                   "BannerName":
      //                 });
    }
  );

  /******* Click on humburger menu *********/
  jQuery(document).on("click", "#pageheader .mobile-nav-toggle", function () {
    clevertap.event.push("HamburgerMenuUsed");
  });

  /******* Click on PDP Similar Product *********/
  jQuery(document).on("click", ".pdp-similar .CT_product-block .product-link", function () {
    var productCard = jQuery(this).closest(".CT_product-block");

    clevertap.event.push("SimilarProductClicked", {
      ProductID: productCard.attr("data-product-id") || "",
      product_name: productCard.attr("data-product") || "",
      sku: productCard.attr("data-sku") || "",
      product_url: productCard.attr("data-prodURL") || "",
      product_image: productCard.attr("data-imageUrl") || "",
      product_price: Number(String(productCard.attr("data-prodPrice") || "").replace(/[^\d.-]/g, "")) || 0,
      product_occasion: productCard.attr("data-prodOccation") || "",
      product_type: productCard.attr("data-product-type") || "",
      utm_campaign: utm_campaign || "",
      utm_medium: utm_medium || "",
      utm_source: utm_source || "",
      user_source: source || "",
      entry_point: "pdp_similar"
    });
  });

  /******* Click on Product Image *********/
  jQuery(document).on(
    "click",
    ".product-media  .CT-rimage__image",
    function () {
      // Trimmed for the same reason as "Viewed Product" above.
      var prod_title = jQuery(".product-form .title-row .title").text().trim();
      clevertap.event.push("Product Image Clicked", {
        product_name: prod_title,
      });
    }
  );

  /******* Click on Cart Icon click  *********/
  jQuery(document).on("click", ".mm-ajaxcart-open", function () {
    clevertap.event.push("Clicked Cart");
  });

  /******* Click on Banner Click  *********/
  jQuery(document).on(
    "click",
    ".slick-track .ct_slide .image-overlay__image-link",
    function () {
      var destination = jQuery(this).attr("href");
      var banner_position = jQuery(this)
        .closest(".ct_slide")
        .attr("data-slick-index");
      var segments = destination.split("/");
      var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

      let toApp = {
        BannerID: banner_position,
        BannerPosition: banner_position,
        DestinationPageURL: destination,
        BannerName: banner_name,
      }

      if (window.KushalsNativeCleverTap) {
        KushalsNativeCleverTap.pushEvent("BannerClicked",JSON.stringify(toApp));
      } else {
        clevertap.event.push("BannerClicked", {
          BannerID: banner_position,
          BannerPosition: banner_position,
          DestinationPageURL: destination,
          BannerName: banner_name,
        });
      }
    }
  );
  /******* Click on Banner Click for ALL Others   *********/
  jQuery(document).on("click", ".ct_banner_click_clevertap", function (e) {
    e.preventDefault(); // Prevent immediate redirect

    var destination = jQuery(this).attr("href");
    var banner_position = jQuery(this).attr("data-count");
    var segments = destination.split("/");
    var banner_name = segments.pop() || segments.pop(); // Handles trailing slash

    // Push event to CleverTap

    let toApp = {
      BannerID: banner_position,
      BannerPosition: banner_position,
      DestinationPageURL: destination,
      BannerName: banner_name,
    }

    if (window.KushalsNativeCleverTap) {
      KushalsNativeCleverTap.pushEvent("BannerClicked",JSON.stringify(toApp));
    } else {
      clevertap.event.push("BannerClicked", {
        BannerID: banner_position,
        BannerPosition: banner_position,
        DestinationPageURL: destination,
        BannerName: banner_name,
      });
    }
    // Redirect after a slight delay to ensure the event is sent
    setTimeout(function () {
      window.location.href = destination;
    }, 500); // Adjust the delay if needed
  });

  /******* Click on Location Click  *********/
  jQuery(document).on("click", ".ct_location", function () {
    var page_name = getLastWordFromURL();

    clevertap.event.push("Clicked Store Locator", {
      page_name: page_name,
    });
  });

  /******* Click on collection sort by  *********/
  jQuery(document).on("click", ".CT_link-dropdown__options a", function () {
    var ct_sort = jQuery(this).find(".ct_cl_sort").text();
    var page_url = window.location.href;
    clevertap.event.push("Sort Applied", {
      sort_type: ct_sort,
      landingpage_url: page_url,
    });
  });
  /******* Click on Product description  *********/
  jQuery(document).on("click", ".cc-accordion-item__title", function () {
    clevertap.event.push("checked_product_description", {
      checked_product_description: "click",
    });
  });
  /******* Click on humburger menu *********/
  jQuery(document).on("click", ".mobile-nav-toggle", function () {
    clevertap.event.push("Clicked Navigation");
  });

  /******* Click on Login Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#customer_email").val();
    var password = jQuery("#customer_password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Login", {
        Method_Used: "shopify",
        Login_Status: "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Login", {
          Method_Used: "shopify",
          Login_Status: "failed",
        });
      }
    }
  });

  $("#one-click-social-login-buttons-1").on("load", function () {
    var iframeContent = $(this).contents(); // Access the iframe content

    iframeContent.find(".btn-google-plus").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "Google",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });

    iframeContent.find(".btn-facebook").on("click", function (event) {
      event.preventDefault(); // Prevent the default googleLogin() from being called
      alert("Custom Google Login triggered");

      // Your custom login logic goes here
      clevertap.event.push("Login", {
        Method_Used: "facebook",
        Login_Status: "success",
      });

      // Optionally, open Google login window or redirect
      // window.open('YOUR_GOOGLE_LOGIN_URL', '_blank'); // replace with actual login URL
    });
  });

  /******* Click on Sign up Btn *********/
  jQuery(document).on("click", "#customer .action_bottom button", function (e) {
    var email = jQuery("#email").val();
    var password = jQuery("#password").val();
    if (email != "" && password != "") {
      clevertap.event.push("Sign Up", {
        Method_Used: "shopify",
        "Signup _Status": "success",
      });
    } else {
      if (email != "" && password != "") {
        clevertap.event.push("Sign Up", {
          Method_Used: "shopify",
          "Signup _Status": "failed",
        });
      }
    }
  });

  /******* Search input click *********/
  function pushCleverTapEvent(eventName, payload) {
    try {
      if (window.clevertap?.event?.push) clevertap.event.push(eventName, payload);
    } catch (err) {
      console.error('CleverTap push failed', err);
    }
  }

  const searchBar = document.querySelector('.ct_main-search__input');
  if (searchBar) {
    searchBar.addEventListener('click', () => {
      const pageName = typeof page !== 'undefined' ? page : window.location.pathname;
      pushCleverTapEvent('Clicked Search Bar', { page_name: pageName });
    });
  }

  // --- mutation observer: watch once ---
  const observer = new MutationObserver(() => {
    attachSuggestionListeners();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function attachSuggestionListeners() {
    // suggestion items (collections etc.)
    document
      .querySelectorAll(
        '.wizzy-autocomplete-suggestions .autocomplete-suggestions-list .autocomplete-item a'
      )
      .forEach((item) => {
        if (item.dataset.ctBound === '1') return;
        item.dataset.ctBound = '1';

        item.addEventListener('click', (e) => {
          const searchTerm = item.textContent.trim();
          pushCleverTapEvent('Search AutoSuggestion_clicked', {
            AutoSuggestion_value: searchTerm,
            type: 'collection',
          });
        });
      });

    // product items
    document
    .querySelectorAll('.autocomplete-top-products .topproduct-item a')
    .forEach((link) => {
      if (link.dataset.ctBound === '1') return;
      link.dataset.ctBound = '1';

      link.addEventListener(
        'click',
        (function () {
          let fired = false;
          return function (e) {
            if (fired) return;
            fired = true;

            const searchTerm =
              link.closest('li')?.getAttribute('title') ||
              link.getAttribute('title') ||
              link.textContent.trim();

            pushCleverTapEvent('Search AutoSuggestion_clicked', {
              AutoSuggestion_value: searchTerm,
              type: 'product',
            });

            e.preventDefault();
            setTimeout(() => {
              window.location.href = link.href;
            }, 400);
          };
        })()
      );
    });
  }

  // ---------------------
  // NEW SEARCH INPUT (#search)
  // ---------------------
  const newSearchInput = document.querySelector('#search');

  if (newSearchInput) {
    newSearchInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        const searchQuery = newSearchInput.value.trim();

        if (searchQuery) {
          pushCleverTapEvent('Searched', {
            search_query: searchQuery,
          });
        }
      }
    });
  }


  // run once immediately
  attachSuggestionListeners();

  /******* hamburger menu click *********/
  jQuery(document).on("click", ".ct_navigation__item", function () {
    var item = jQuery(this).find(".navigation__link:first").text();
    var main_menu_click = {
      "Item Name": item,
    };
    clevertap.event.push("HamburgerMenu Item Clicked", main_menu_click);
  });

  /******* hamburger menu click *********/
  jQuery(document).on(
    "click",
    ".navigation__tier-3 .navigation__item",
    function () {
      var item = jQuery(this).find(".navigation__link:first").text();
      var main_menu_click = {
        "Item Name": item,
      };
      clevertap.event.push("Hamburger Submenu Clicked", main_menu_click);
    }
  );
  /******* All circle click event *********/
  jQuery(document).on("click", ".all_circle_click_clickpost", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var collection_title = jQuery(
      ".container  .overlay-text__inner:first .overlay-text__title"
    ).text();
    var coll_name = jQuery(this).attr("data-name");
    var page_url = window.location.href;
    var circle_coll_click = {
      "Category Name": collection_title,
      "Page URL": page_url,
      "Landing Page URL": link,
    };
    clevertap.event.push("Circle Menu Clicked", circle_coll_click);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });

  jQuery(document).on("click", ".call-banner a", function (e) {
    e.preventDefault();
    var link = jQuery(this).attr("href");
    var lastWord = getLastWordFromURL();
    var bridal = {
      Phone: link,
      Page: lastWord,
    };
    clevertap.event.push("Call_Stylist", bridal);
    setTimeout(function () {
      window.location.href = link;
    }, 500);
  });
});

// PLP Product Click Event
document.addEventListener('click', function (e) {
  if (!(window.page === 'collection' || document.body.classList.contains('template-collection'))) return;

  const product = e.target.closest('.CT_product-block.product-block');
  if (!product) return;

  let productId = product.getAttribute('data-product-id');
  let prodPrice = product.getAttribute('data-prodprice');
  let prodUrl = product.getAttribute('data-prodURL');
  let imageUrl = product.getAttribute('data-imageUrl');
  let prodCategory = product.getAttribute('data-prodcategory');
  let prodSubCategory = product.getAttribute('data-prodsubcategory');
  let prodOccation = product.getAttribute('data-prodoccation');
  let currentPage = parseInt(product.getAttribute('data-currentpage'), 10);
  let currentPosition = parseInt(product.getAttribute('data-currentposition'), 10);
  let isPinned = product.getAttribute('data-ispinned') === 'true';
  let collectionTitle = product.getAttribute('data-collection');
  let productTitle = product.getAttribute('data-product');

  // Adjust position if not on first page
  if (currentPage !== 1) {
    let firstPageProduct = document.querySelectorAll('.first-page-prod');

    if (firstPageProduct.length > 0) {
      let pinnedCount = parseInt(firstPageProduct[0].getAttribute('data-pinnedCount') || '0', 10);
      let nonPinnedCount = parseInt(firstPageProduct[0].getAttribute('data-nonpinnedCount') || '0', 10);

      currentPosition += pinnedCount + nonPinnedCount + ((currentPage - 2) * 16);
    }
  }

  clevertap.event.push("PLP Product Clicked", {
    product_id: productId,
    current_position: currentPosition,
    is_pinned: isPinned,
    collection_title: collectionTitle,
    product_title: productTitle,
    prodPrice: toNumericPrice(prodPrice),
    prodUrl: prodUrl,
    imageUrl: imageUrl,
    prodCategory: prodCategory,
    prodSubCategory: prodSubCategory,
    prodOccation: prodOccation
  });
});


//UTM Parameters Event
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source') || '';
  const utmMedium = urlParams.get('utm_medium') || '';
  const utmCampaign = urlParams.get('utm_campaign') || '';

  const cleanUrl = window.location.origin + window.location.pathname;

  let toApp = {
    page_url: cleanUrl,
    page_title: document.title,
    page_type: __st.p,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign
  }

  const isJewelleryFinderPage = window.location.pathname.includes('find-your-perfect-sparkle') || window.location.pathname.includes('find-the-one') || window.location.pathname.includes('product-finder');
  // Gift Finder wizard: gate on the template suffix (body class from
  // layout/theme.liquid), not the page handle. The live page is /pages/finder,
  // so the old handle checks never matched and "Page Browsed" fired alongside
  // finder_started. The handle fallbacks stay for any older page still on them.
  const isGiftFinderPage = document.body.classList.contains('template-suffix-gift-finder-for-her') || window.location.pathname.includes('gift-finder-for-her') || window.location.pathname.includes('gift-finder');

  if (!isJewelleryFinderPage && !isGiftFinderPage) {
    if (window.KushalsNativeCleverTap) {
      KushalsNativeCleverTap.pushEvent("Page Browsed",JSON.stringify(toApp));
    } else {
      clevertap.event.push("Page Browsed", {
        page_url: cleanUrl,
        page_title: document.title,
        page_type: __st.p,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign
      });
    }
  }
});

if(window.page === 'collection') {
  const page_name = document.querySelector('.ct_header_title-main').textContent;
  clevertap.event.push('Category_Browsed', {
    last_page: document.referrer,
    page_url: window.location.href,
    page_name: page_name,
  })
}


const appDownloadBanner = document.querySelectorAll('.app-download-banner-inner');

document.addEventListener('click', (event) => {
  const banner = event.target.closest('.app-download-banner-inner');
  if (!banner) return;
  clevertap.event.push('App Download Banner Clicked', {
    page_url: window.location.href,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ? 'Yes' : 'No'
  });
});


kReelsCTProductATC = function(params){
  try{
    const p = params || {};
    clevertap.event.push("Product CTA Click", {
      video_id: String(p.video_id || ""),
      product_id: String(p.product_id || ""),
      product_title: String(p.product_title || ""),
      action_type: "AddToCart",
      placement: "LP"
    });
  }catch(e){}
};


/* ============================================================================
   PLP ANALYTICS — "Analytics & Measurement — PLP Upgrade"

   Four new/extended CleverTap events, kept in one block so the spec reads
   straight off the code:

     Viewed Product Spotlight   full-width spotlight card >=50% visible for >=1s,
                                once per card per collection view
     Clicked Product Spotlight  spotlight card tapped
     Viewed Banner              pinned promotional creative renders above the
                                grid, once per collection view
     Clicked Banner             pinned banner tapped
     Viewed Product             EXTENDED with entry_point (append only — the
                                event is not renamed, live campaigns bind to it)

   Every event above also carries the four base properties from spec section 1:
   plp_version, page_type, collection_name, collection_handle. They come from
   window.__K_PLP_ANALYTICS__, emitted by sections/main-collection.liquid.
   CT Source and CT Session Id are populated by the SDK and are never sent here.

   The spotlight IS the full-width hero card (.product-hero-card) rendered by
   snippets/product-hero-block.liquid at every 7th grid slot.

   "PLP Product Clicked" below is deliberately left alone: a spotlight tap fires
   both it and Clicked Product Spotlight, because removing it would break the
   campaigns already bound to it.
   ========================================================================== */
(function () {
  'use strict';

  window.__K_PLP_ANALYTICS_INIT_COUNT__ = (window.__K_PLP_ANALYTICS_INIT_COUNT__ || 0) + 1;
  console.log('[KUSHALS-DEBUG] PLP analytics module init #', window.__K_PLP_ANALYTICS_INIT_COUNT__);

  var ENTRY_POINT_KEY = 'k_plp_entry_point';

  // Spec: ">=50% visible for >=1s".
  var VIEW_RATIO = 0.5;
  var VIEW_DWELL_MS = 1000;

  var CARD_SELECTOR = '.CT_product-block.product-block';
  var HERO_SELECTOR = '.product-hero-card';
  var BANNER_SELECTOR = '[data-k-plp-banner]';
  // Wizzy owns search, and it renders its results in an OVERLAY that can open on
  // any page — the homepage, a PLP, anywhere the header magnifier is. A product
  // opened from there is a search entry whatever template is underneath, so this
  // is tested before the page type is. Class list from
  // snippets/wizzy.search.results.products.js.liquid; .wizzy-product-<id> is
  // per-product, so the stable classes are used instead.
  //
  // Those results carry `product-block` but NOT `CT_product-block`, so they
  // never matched CARD_SELECTOR — a search tap on a PLP simply recorded nothing,
  // and on the homepage it recorded 'home'.
  var SEARCH_RESULT_SELECTOR = '.wizzy-result-product, .ct-search-product-box, .wizzy-search-results-wrapper';
  var GRID_SELECTOR = '.product-list';

  /* --- small DOM helpers ------------------------------------------------ */

  function attr(el, name) {
    if (!el || !el.getAttribute) return '';
    var v = el.getAttribute(name);
    return v == null ? '' : v;
  }

  // Element.closest, but safe when the click landed on an SVG child or a text
  // node — both happen on these cards (the wishlist heart is inline SVG).
  function closest(node, selector) {
    var el = node;
    while (el && el.nodeType !== 1) el = el.parentNode;
    while (el) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function toNumber(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? '' : n;
  }

  function isCollectionPage() {
    return window.page === 'collection'
      || document.body.classList.contains('template-collection')
      || (typeof __st !== 'undefined' && __st && __st.p === 'collection');
  }

  /* --- base properties + push ------------------------------------------- */

  function baseProps() {
    var cfg = window.__K_PLP_ANALYTICS__ || {};
    return {
      plp_version: cfg.plp_version || '',
      page_type: cfg.page_type || 'collection',
      collection_name: cfg.collection_name || '',
      collection_handle: cfg.collection_handle || ''
    };
  }

  function push(eventName, props) {
    try {
      var payload = baseProps();
      for (var key in props) {
        if (Object.prototype.hasOwnProperty.call(props, key)) payload[key] = props[key];
      }
      if (window.clevertap && clevertap.event) clevertap.event.push(eventName, payload);
    } catch (e) {}
  }

  /* --- entry_point ------------------------------------------------------ */

  // "Viewed Product" fires on the PDP, not on the PLP, so the surface that sent
  // the customer there has to be recorded at click time and read back one page
  // later. sessionStorage, not localStorage: the label belongs to this tab's
  // journey, and a second tab opened straight onto a PDP must not inherit it.
  function setEntryPoint(value) {
    try { sessionStorage.setItem(ENTRY_POINT_KEY, value); } catch (e) {}
  }

  // Read-and-clear. The value describes how THIS product page was reached, so a
  // later direct or deep-linked PDP must not report the previous hop's surface.
  window.kPlpEntryPoint = function () {
    var value = '';
    try {
      value = sessionStorage.getItem(ENTRY_POINT_KEY) || '';
      sessionStorage.removeItem(ENTRY_POINT_KEY);
    } catch (e) {}
    return value;
  };

  // The non-PLP half of the enum (search | shop_page | home). plp_grid,
  // plp_spotlight and plp_banner are set from the PLP click handler instead,
  // where the exact surface tapped is known.
  function nonPlpEntryPoint() {
    var template = (typeof __st !== 'undefined' && __st) ? __st.p : '';
    var path = window.location.pathname;

    if (template === 'search' || path.indexOf('/search') === 0) return 'search';
    if (template === 'home' || path === '/') return 'home';
    if (template === 'page' && path.indexOf('shop') !== -1) return 'shop_page';
    return '';
  }

  /* --- spotlight properties --------------------------------------------- */

  // Same offset math as "PLP Product Clicked" above: past page 1 the card's own
  // data-currentposition restarts, so the first page's pinned + non-pinned
  // counts (parked on .first-page-prod) plus 16 per intervening page are added
  // back. Kept as its own function rather than shared with that handler so the
  // live event keeps its exact current behaviour.
  function slotPosition(card) {
    var currentPage = parseInt(attr(card, 'data-currentpage'), 10);
    var position = parseInt(attr(card, 'data-currentposition'), 10);
    if (isNaN(position)) return '';

    if (!isNaN(currentPage) && currentPage !== 1) {
      var firstPageProduct = document.querySelectorAll('.first-page-prod');
      if (firstPageProduct.length > 0) {
        var pinnedCount = parseInt(firstPageProduct[0].getAttribute('data-pinnedCount') || '0', 10) || 0;
        var nonPinnedCount = parseInt(firstPageProduct[0].getAttribute('data-nonpinnedCount') || '0', 10) || 0;
        position += pinnedCount + nonPinnedCount + ((currentPage - 2) * 16);
      }
    }
    return position;
  }

  // 0-based rank of this spotlight among the spotlights on the page, read from
  // the DOM at fire time rather than stamped in Liquid: after a filter,
  // buildHeroCardHtml() in assets/k-custom-filter.js promotes standard cards
  // into heroes client-side, so any server-rendered index would be stale.
  function spotlightIndex(card) {
    var heroes = document.querySelectorAll(HERO_SELECTOR);
    for (var i = 0; i < heroes.length; i++) {
      if (heroes[i] === card) return i;
    }
    return -1;
  }

  // product_name is the join key against "Viewed Product" and must be Shopify's
  // title verbatim, trailing product digits included — data-product is
  // product.title, so it already is.
  //
  // product_price is data-prodPrice (money_without_currency), a STRING, which is
  // what "Viewed Product" sends on the PDP: it strips the currency off the
  // rendered price text. Keep both sides strings — see spec section 3.
  function spotlightProps(card, includeViewOnly) {
    var props = {
      product_name: attr(card, 'data-product'),
      sku: attr(card, 'data-sku'),
      product_price: attr(card, 'data-prodPrice'),
      slot_position: slotPosition(card),
      spotlight_index: spotlightIndex(card)
    };

    if (includeViewOnly) {
      props.product_type = attr(card, 'data-product-type');
      props.image_count = toNumber(attr(card, 'data-image-count'));
      props.product_url = attr(card, 'data-prodURL');
      props.product_image = attr(card, 'data-imageUrl');
    }
    return props;
  }

  /* --- once-per-collection-view guards ---------------------------------- */

  var seenSpotlights = {};
  var seenBanners = {};
  var viewPath = window.location.pathname;

  // A filter or a sort in fast mode rewrites the grid without a reload, but it
  // is still the same collection view, so the guards must survive it — only a
  // different collection (a pathname change) starts a new view. Cards that
  // arrive with a filter are unseen anyway and report on their own.
  function resetIfNewCollectionView() {
    if (window.location.pathname === viewPath) return;
    console.log('[KUSHALS-DEBUG] resetIfNewCollectionView — CLEARING guards. was:', viewPath,
      'now:', window.location.pathname);
    viewPath = window.location.pathname;
    seenSpotlights = {};
    seenBanners = {};
  }

  /* --- Viewed Product Spotlight ----------------------------------------- */

  var spotlightObserver = null;

  function fireSpotlightView(card) {
    resetIfNewCollectionView();

    var key = attr(card, 'data-product-id') || attr(card, 'data-product');
    var debugPid = attr(card, 'data-product-id');
    console.log('[KUSHALS-DEBUG] fireSpotlightView — key:', key,
      'alreadySeen:', !!seenSpotlights[key],
      'moduleInit#:', window.__K_PLP_ANALYTICS_INIT_COUNT__,
      'pos:', attr(card, 'data-currentposition'),
      'heroIndex:', spotlightIndex(card),
      'heroesInDom:', document.querySelectorAll(HERO_SELECTOR).length,
      'nodesWithSameId:', debugPid ? document.querySelectorAll('[data-product-id="' + debugPid + '"]').length : 'n/a',
      'imageUrl:', attr(card, 'data-imageUrl'),
      'viewPath:', viewPath, 'path:', window.location.pathname);
    if (!key || seenSpotlights[key]) return;
    seenSpotlights[key] = true;

    push('Viewed Product Spotlight', spotlightProps(card, true));
    if (spotlightObserver) spotlightObserver.unobserve(card);
  }

  function ensureSpotlightObserver() {
    if (spotlightObserver || typeof IntersectionObserver === 'undefined') return spotlightObserver;

    spotlightObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var card = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= VIEW_RATIO) {
          // Already counting down — a second crossing must not start a second
          // timer, or a card scrubbed past the 50% line would fire twice.
          if (card.__kSpotlightTimer) continue;
          card.__kSpotlightTimer = window.setTimeout((function (target) {
            return function () {
              target.__kSpotlightTimer = null;
              fireSpotlightView(target);
            };
          })(card), VIEW_DWELL_MS);
        } else if (card.__kSpotlightTimer) {
          // Scrolled back out inside the dwell window: not a view.
          window.clearTimeout(card.__kSpotlightTimer);
          card.__kSpotlightTimer = null;
        }
      }
    }, { threshold: [VIEW_RATIO] });

    return spotlightObserver;
  }

  function scanSpotlights() {
    var observer = ensureSpotlightObserver();
    if (!observer) return;

    var heroes = document.querySelectorAll(HERO_SELECTOR);
    for (var i = 0; i < heroes.length; i++) {
      var card = heroes[i];
      if (card.__kSpotlightObserved) continue;

      var key = attr(card, 'data-product-id');
      if (key && seenSpotlights[key]) continue;

      card.__kSpotlightObserved = true;
      observer.observe(card);
    }
  }

  /* --- Viewed Banner ----------------------------------------------------

     Markup contract for a pinned PLP banner — add these to the creative's
     wrapper and both banner events start reporting with no JS change:

       <div data-k-plp-banner
            data-banner-id="..."
            data-banner-name="..."
            data-banner-type="promo|offer|delivery_usp|campaign"
            data-banner-position="1"
            data-banner-image="https://..."
            data-banner-url="https://..."
            data-destination-type="collection|product|offer_page|external"
            data-destination-handle="..."
            data-is-personalized="true|false">

     No pinned banner renders above the PLP grid today, so these two events are
     dormant until one ships. The in-grid app-download banner is NOT one: it is
     a grid slot, not a pinned creative above the grid, and it has its own
     "App Download Banner Clicked" event.
     -------------------------------------------------------------------- */

  function bannerIdentity(el) {
    return {
      banner_id: attr(el, 'data-banner-id'),
      banner_name: attr(el, 'data-banner-name'),
      banner_type: attr(el, 'data-banner-type'),
      banner_position: toNumber(attr(el, 'data-banner-position'))
    };
  }

  function scanBanners() {
    resetIfNewCollectionView();

    var banners = document.querySelectorAll(BANNER_SELECTOR);
    for (var i = 0; i < banners.length; i++) {
      var el = banners[i];
      var key = attr(el, 'data-banner-id') || attr(el, 'data-banner-name');
      if (!key || seenBanners[key]) continue;
      seenBanners[key] = true;

      var props = bannerIdentity(el);
      props.banner_image = attr(el, 'data-banner-image');
      props.is_personalized = attr(el, 'data-is-personalized') === 'true';

      push('Viewed Banner', props);
    }
  }

  /* --- clicks ------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    if (!isCollectionPage()) return;

    // Search overlay open over the PLP: a search entry, not a grid one.
    if (closest(event.target, SEARCH_RESULT_SELECTOR)) {
      if (closest(event.target, 'a[href*="/products/"]')) setEntryPoint('search');
      return;
    }

    var banner = closest(event.target, BANNER_SELECTOR);
    if (banner) {
      setEntryPoint('plp_banner');

      var bannerProps = bannerIdentity(banner);
      bannerProps.banner_url = attr(banner, 'data-banner-url');
      bannerProps.destination_type = attr(banner, 'data-destination-type');
      bannerProps.destination_handle = attr(banner, 'data-destination-handle');

      push('Clicked Banner', bannerProps);
      return;
    }

    var card = closest(event.target, CARD_SELECTOR);
    if (!card) return;

    // entry_point describes how the PDP was REACHED, so it is only stamped when
    // the tap actually navigates to a product. The wishlist heart and the
    // carousel dots sit outside the card's <a class="product-link"> and go
    // nowhere — stamping on those would leave a stale plp_grid in
    // sessionStorage for whatever PDP the customer opened next.
    if (closest(event.target, 'a[href*="/products/"]')) {
      setEntryPoint(card.classList.contains('product-hero-card') ? 'plp_spotlight' : 'plp_grid');
    }

    // The event itself stays card-level, matching "PLP Product Clicked" above:
    // both count a tap anywhere on the card, so the two stay comparable in
    // CleverTap instead of diverging by the wishlist and dot taps.
    if (card.classList.contains('product-hero-card')) {
      push('Clicked Product Spotlight', spotlightProps(card, false));
    }
  });

  // Everywhere that is not a PLP: record the surface so the PDP's
  // "Viewed Product" can report entry_point for search / shop_page / home too.
  document.addEventListener('click', function (event) {
    if (isCollectionPage()) return;

    if (!closest(event.target, 'a[href*="/products/"]')) return;

    // The overlay wins over the template underneath it.
    if (closest(event.target, SEARCH_RESULT_SELECTOR)) {
      setEntryPoint('search');
      return;
    }

    var surface = nonPlpEntryPoint();
    if (!surface) return;

    setEntryPoint(surface);
  });

  /* --- init + regrid ----------------------------------------------------- */

  function init() {
    if (!isCollectionPage()) return;

    scanSpotlights();
    scanBanners();

    // The fast filter rewrites the grid in place and dispatches no event of its
    // own, so the rescan is driven off the DOM. Debounced because a rewrite
    // lands as a burst of mutations, and safe from feedback: nothing in here
    // writes to the DOM (the per-card flags are JS properties, not attributes).
    if (!window.MutationObserver) return;

    var grid = document.querySelector(GRID_SELECTOR) || document.body;
    var rescanTimer = null;

    new MutationObserver(function () {
      if (rescanTimer) return;
      rescanTimer = window.setTimeout(function () {
        rescanTimer = null;
        scanSpotlights();
        scanBanners();
      }, 200);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================================
   PDP MODULE ANALYTICS — Recommendations / View similar / Store inventory /
   Appointment / Size & Fit  (events sheet, 2026-10)

   One block, one helper. Event NAMES live in the PDP_EVENTS map below so a
   rename in the sheet is a one-line change here. Modules that know things this
   file cannot see (API success/failure, modal steps) call window.kPdpTrack
   through a tiny shim: if the helper is not defined yet they push onto
   window.__kPdpTrackQueue and this block drains it on load.

   Every event carries the PDP base props (product_name, sku, product_url,
   product_price, product_id, variant_id, platform) plus the event's own props.
   In the native app webview the event goes to KushalsNativeCleverTap, else to
   web CleverTap — same split as "Page Browsed" above.

   Existing events (Reserve_Submit_clicked, book_appointment_click, Shop by
   collection Product Click, ATC_NoSize_SizeChartPopup_Shown, …) are NOT
   renamed or removed — live campaigns are bound to them. The new names fire
   alongside.
   ========================================================================== */
(function () {
  'use strict';

  var PDP_EVENTS = {
    // Recommendations ("Explore more" grid, mobile only — assets/pdp-explore.js)
    recommendation_module_viewed: 'recommendation_module_viewed',
    recommendation_product_clicked: 'recommendation_product_clicked',
    recommendation_added_to_cart: 'recommendation_added_to_cart',
    // OOS / View similar (assets/custom.js .get-similar-products popup)
    // NOTE: sheet rows 4-6 were hidden in the screenshot — these three names
    // are a best guess, rename here once confirmed.
    view_similar_cta_clicked: 'view_similar_cta_clicked',
    view_similar_module_viewed: 'view_similar_module_viewed',
    view_similar_product_clicked: 'view_similar_product_clicked',
    view_similar_added_to_cart: 'view_similar_added_to_cart',
    view_similar_api_failed: 'view_similar_api_failed',
    // Store inventory (assets/store-locator.js, assets/pdp-delivery-stores.js)
    store_availability_viewed: 'store_availability_viewed',
    store_inventory_cta_clicked: 'store_inventory_cta_clicked',
    store_inventory_reserve_confirmed: 'store_inventory_reserve_confirmed',
    store_inventory_reserve_failed: 'store_inventory_reserve_failed',
    // Appointment (assets/appointment-modal.js)
    appointment_cta_clicked: 'appointment_cta_clicked',
    appointment_modal_viewed: 'appointment_modal_viewed',
    appointment_store_selected: 'appointment_store_selected',
    appointment_date_selected: 'appointment_date_selected',
    appointment_time_selected: 'appointment_time_selected',
    appointment_confirmed: 'appointment_confirmed',
    appointment_failed: 'appointment_failed',
    // Size / Fit (snippets/variant-picker.liquid, snippets/size-guide.liquid, theme.js validateProductForm)
    size_selected: 'size_selected',
    size_chart_viewed: 'size_chart_viewed',
    atc_blocked_no_size: 'atc_blocked_no_size'
  };
  window.__K_PDP_EVENTS__ = PDP_EVENTS;

  // sessionStorage key for "which PDP module sent the customer to this product"
  // — read back on the next PDP add-to-cart to attribute *_added_to_cart.
  var SOURCE_MODULE_KEY = 'k_pdp_source_module';
  // CleverTap stamps events to the second: a follow-up event that must LIST
  // after its trigger (cta → modal, block → chart) is delayed by this much.
  var ORDERING_DELAY_MS = 1100;
  window.__K_PDP_ORDERING_DELAY_MS__ = ORDERING_DELAY_MS;

  function isProductPage() {
    return (typeof __st !== 'undefined' && __st && __st.p === 'product')
      || document.body.classList.contains('template-product');
  }

  function text(el) { return el ? String(el.textContent || '').trim() : ''; }
  function attr(el, name) { return el ? (el.getAttribute(name) || '') : ''; }
  function num(value) {
    var n = Number(String(value == null ? '' : value).replace(/[^\d.-]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }
  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }
  function handleFromPath() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function readJson(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  /* --- base props ------------------------------------------------------- */

  function selectedVariantInput() {
    return document.querySelector('.product-form select[name="id"]')
      || document.querySelector('.product-form [name="id"]')
      || document.querySelector('form select[name="id"]')
      || document.querySelector('form [name="id"]');
  }
  function selectedSku(variantInput) {
    var select = variantInput && variantInput.tagName === 'SELECT' ? variantInput : document.querySelector('select[name="id"]');
    var option = select && select.options[select.selectedIndex];
    return (option && attr(option, 'data-sku'))
      || attr(document.querySelector('.stInventory-overlay'), 'data-sku')
      || attr(document.querySelector('.explpre-collections-container'), 'data-sku')
      || '';
  }

  /* --- Base Payload (events sheet "Base Payload" tab) --------------------
     event_timestamp, session_id, anonymous_id, customer_id, login_status,
     platform, app_version, page_type, page_url, referrer_url, screen_name,
     previous_screen_name, source_component, source_component_id,
     experiment_id, variant_id_experiment — on EVERY event sent through
     kPdpTrack, before the event's own props. ------------------------------ */

  var ANON_KEY = 'k_anonymous_id';
  var SESSION_KEY = 'k_session_id';
  var SCREEN_KEY = 'k_screen_name';
  var PREV_SCREEN_KEY = 'k_previous_screen_name';

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
  // Visitor/device id. Seeded from Shopify's own persistent visitor cookie
  // (_shopify_y) so it lines up with Shopify analytics, persisted so it stays
  // stable if that cookie is ever cleared or blocked.
  function anonymousId() {
    try {
      var v = localStorage.getItem(ANON_KEY);
      if (!v) { v = cookie('_shopify_y') || uuid(); localStorage.setItem(ANON_KEY, v); }
      return v;
    } catch (e) { return cookie('_shopify_y') || ''; }
  }
  // Session id: one per browser tab session, seeded from Shopify's _shopify_s.
  function sessionId() {
    try {
      var v = sessionStorage.getItem(SESSION_KEY);
      if (!v) { v = cookie('_shopify_s') || uuid(); sessionStorage.setItem(SESSION_KEY, v); }
      return v;
    } catch (e) { return cookie('_shopify_s') || ''; }
  }
  // Shopify customer id: __st.cid is set by Shopify for a logged-in customer;
  // snippets/analytical_scripts.liquid also exposes shopifyCartEvent.customer.id.
  function customerId() {
    try {
      if (typeof __st !== 'undefined' && __st && __st.cid) return String(__st.cid);
      if (window.shopifyCartEvent && shopifyCartEvent.customer && shopifyCartEvent.customer.id) return String(shopifyCartEvent.customer.id);
    } catch (e) {}
    return '';
  }
  function isAppWebview() {
    return !!(window.webview || window.KushalsNativeCleverTap || document.documentElement.classList.contains('app_hide_elements'));
  }
  // web | mweb | ios | android (sheet enum). The app webview flag comes from
  // ?webview=… (layout/theme.liquid); the OS from the UA.
  function platform() {
    var ua = navigator.userAgent || '';
    if (isAppWebview()) {
      if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
      if (/Android/i.test(ua)) return 'android';
      return 'app';
    }
    var mobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua) || (window.matchMedia && matchMedia('(max-width: 767px)').matches);
    return mobile ? 'mweb' : 'web';
  }
  // App build version when the app passes one (window.__K_APP_VERSION__ or
  // ?app_version=), else the web release = theme name + id.
  function appVersion() {
    if (window.__K_APP_VERSION__) return String(window.__K_APP_VERSION__);
    var fromUrl = '';
    try { fromUrl = new URLSearchParams(window.location.search).get('app_version') || ''; } catch (e) {}
    if (fromUrl) return fromUrl;
    var t = window.Shopify && Shopify.theme;
    return t ? (String(t.name || 'theme') + '#' + String(t.id || '')) : 'theme';
  }
  var PAGE_TYPE_MAP = { index: 'home', collection: 'plp', product: 'pdp', cart: 'cart', search: 'search', page: 'page', article: 'blog', blog: 'blog', list_collections: 'collections', customers: 'account', '404': '404', password: 'password', gift_card: 'gift_card' };
  function pageType() {
    var p = (typeof __st !== 'undefined' && __st && __st.p) || '';
    if (/^customers/.test(p)) return 'account';
    if (/checkout/.test(window.location.pathname)) return 'checkout';
    return PAGE_TYPE_MAP[p] || p || '';
  }
  // "no sensitive data": origin + path only — query strings can carry tokens,
  // OTP callbacks, discount codes and email prefills.
  function cleanUrl(href) {
    try { var u = new URL(href, window.location.origin); return u.origin + u.pathname; } catch (e) { return ''; }
  }
  function screenName() {
    return String(document.title || '').replace(/\s*[\u2013\u2014|-]\s*Kushal.*$/i, '').trim() || pageType();
  }
  // previous_screen_name: stamped once per page load from what the last page
  // in this tab wrote, then this page's name is written for the next one.
  var previousScreenName = '';
  (function rotateScreen() {
    try {
      var current = screenName();
      var last = sessionStorage.getItem(SCREEN_KEY) || '';
      var lastUrl = sessionStorage.getItem(SCREEN_KEY + '_url') || '';
      // A reload of the same URL is not a screen change.
      if (lastUrl && lastUrl === cleanUrl(window.location.href)) {
        previousScreenName = sessionStorage.getItem(PREV_SCREEN_KEY) || '';
      } else {
        previousScreenName = last;
        sessionStorage.setItem(PREV_SCREEN_KEY, last);
      }
      sessionStorage.setItem(SCREEN_KEY, current);
      sessionStorage.setItem(SCREEN_KEY + '_url', cleanUrl(window.location.href));
    } catch (e) {}
  })();
  // source_component by event family; an event's own props can override
  // both source_component and source_component_id.
  function sourceComponentFor(eventName) {
    if (/^recommendation_/.test(eventName)) return { source_component: 'recommendation', source_component_id: 'pdp_explore_more' };
    if (/^view_similar_/.test(eventName)) return { source_component: 'view_similar', source_component_id: 'oos_similar_popup' };
    if (/^store_/.test(eventName)) return { source_component: 'store_inventory', source_component_id: 'pdp_store_availability' };
    if (/^appointment_/.test(eventName)) return { source_component: 'appointment', source_component_id: 'book_appointment_modal' };
    if (/^size_|^atc_blocked/.test(eventName)) return { source_component: 'size_fit', source_component_id: 'variant_picker' };
    return { source_component: '', source_component_id: '' };
  }
  function experiment() {
    var x = window.__K_EXPERIMENT__ || {};
    return { experiment_id: x.id ? String(x.id) : '', variant_id_experiment: x.variant ? String(x.variant) : '' };
  }

  function basePayload(eventName) {
    var cid = customerId();
    var exp = experiment();
    var src = sourceComponentFor(eventName);
    return {
      event_timestamp: new Date().toISOString(),
      session_id: sessionId(),
      anonymous_id: anonymousId(),
      customer_id: cid,
      login_status: !!cid,
      platform: platform(),
      app_version: appVersion(),
      page_type: pageType(),
      page_url: cleanUrl(window.location.href),
      referrer_url: cleanUrl(document.referrer),
      screen_name: screenName(),
      previous_screen_name: previousScreenName,
      source_component: src.source_component,
      source_component_id: src.source_component_id,
      experiment_id: exp.experiment_id,
      variant_id_experiment: exp.variant_id_experiment
    };
  }

  /* --- PDP product context (added after the base payload) ---------------- */

  function baseProps() {
    var titleEl = document.querySelector('.product-form .title-row .title');
    var variantInput = selectedVariantInput();
    var priceWrap = document.querySelector('.price-container .current-price');
    var priceNode = priceWrap && (priceWrap.querySelector('.ct_compare') || priceWrap);
    return {
      product_name: text(titleEl),
      product_url: attr(titleEl, 'data-product-handle') || handleFromPath(),
      product_id: (typeof __st !== 'undefined' && __st && __st.rid) ? String(__st.rid) : '',
      variant_id: variantInput ? String(variantInput.value || '') : '',
      sku: selectedSku(variantInput),
      product_price: num(text(priceNode))
    };
  }

  function track(eventName, props) {
    try {
      var payload = basePayload(eventName);
      var product = baseProps();
      for (var pk in product) {
        if (Object.prototype.hasOwnProperty.call(product, pk)) payload[pk] = product[pk];
      }
      props = props || {};
      for (var key in props) {
        if (Object.prototype.hasOwnProperty.call(props, key) && props[key] !== undefined) {
          payload[key] = props[key];
        }
      }
      // Store-scoped events: the store is the widget instance.
      if (payload.store_id && !props.source_component_id && /^(store_|appointment_)/.test(eventName)) {
        payload.source_component_id = String(payload.store_id);
      }
      if (window.KushalsNativeCleverTap && typeof window.KushalsNativeCleverTap.pushEvent === 'function') {
        window.KushalsNativeCleverTap.pushEvent(eventName, JSON.stringify(payload));
      } else if (window.clevertap && clevertap.event) {
        clevertap.event.push(eventName, payload);
      }
    } catch (e) {
      console.error('[kPdpTrack] push failed', eventName, e);
    }
  }

  window.kPdpTrack = track;

  // Drain anything a module pushed before this file ran.
  (function drainQueue() {
    var queue = window.__kPdpTrackQueue;
    window.__kPdpTrackQueue = [];
    if (!queue || !queue.length) return;
    queue.forEach(function (entry) {
      if (entry && entry[0]) track(entry[0], entry[1]);
    });
  })();

  /* --- source-module attribution (recommendation / view similar → ATC) --- */

  function stampSourceModule(moduleName, props) {
    try {
      sessionStorage.setItem(SOURCE_MODULE_KEY, JSON.stringify({
        module: moduleName,
        target_handle: props.target_handle || '',
        source_product_name: props.source_product_name || '',
        source_sku: props.source_sku || '',
        ts: Date.now()
      }));
    } catch (e) {}
  }
  window.kPdpStampSourceModule = stampSourceModule;

  function consumeSourceModule() {
    var value = readJson(sessionStorage, SOURCE_MODULE_KEY);
    if (!value) return null;
    try { sessionStorage.removeItem(SOURCE_MODULE_KEY); } catch (e) {}
    return value;
  }

  function productCardProps(card) {
    return {
      clicked_product_name: attr(card, 'data-product'),
      clicked_sku: attr(card, 'data-sku'),
      clicked_product_id: attr(card, 'data-product-id'),
      clicked_product_url: attr(card, 'data-prodURL'),
      clicked_product_price: num(attr(card, 'data-prodPrice')),
      clicked_product_type: attr(card, 'data-product-type')
    };
  }

  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* --- store helpers ----------------------------------------------------- */

  function storeProps(box) {
    if (!box) return {};
    var km = box.querySelector('.pdp-ds-km') || box.querySelector('.ct_store_map');
    return {
      store_id: attr(box, 'data-store-id') || attr(box.querySelector('[data-store-id]'), 'data-store-id'),
      store_name: text(box.querySelector('.store-more-name span')) || text(box.querySelector('.store-more-name')),
      store_distance: text(km),
      store_in_stock: box.querySelector('.store-inventory-footer.not-available') ? false : true
    };
  }

  function locationProps() {
    var loc = readJson(localStorage, 'location_store') || {};
    return {
      user_city: loc.city || '',
      user_pincode: loc.postal || loc.pincode || ''
    };
  }

  /* --- delegated listeners (PDP only) ------------------------------------ */

  function init() {
    if (!isProductPage()) return;

    /* Recommendations ("Explore more" grid) — product tap */
    document.addEventListener('click', function (e) {
      var card = closest(e.target, '.explpre-collections-container .CT_product-block');
      if (!card) return;
      if (closest(e.target, '.wishlist_img_main, .ct_hart_icon_main, button, .card-carousel-dots')) return;
      var activeChip = document.querySelector('.explpre-collections-container .collection-tag-pdp.is-active');
      var props = productCardProps(card);
      props.collection_tag = activeChip ? text(activeChip) : '';
      track(PDP_EVENTS.recommendation_product_clicked, props);
      var link = closest(e.target, 'a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      var base = baseProps();
      stampSourceModule('recommendation', {
        target_handle: handleFromHref(attr(link, 'href')) || attr(card, 'data-prodURL'),
        source_product_name: base.product_name,
        source_sku: base.sku
      });
    });

    /* View similar popup — product tap (cards are built after load, so delegate) */
    document.addEventListener('click', function (e) {
      var box = closest(e.target, '.similar_pro_box_img');
      if (!box) return;
      var link = closest(e.target, 'a[href*="/products/"]') || box.querySelector('a[href*="/products/"]');
      var props = {
        clicked_product_name: attr(box, 'data-productname'),
        clicked_product_url: handleFromHref(attr(link, 'href')),
        result_type: closest(box, '.similar_pro_popup_var') ? 'variant' : 'product',
        page_type_trigger: attr(box, 'data-pageType') || attr(box, 'data-pagetype')
      };
      track(PDP_EVENTS.view_similar_product_clicked, props);
      var base = baseProps();
      stampSourceModule('view_similar', {
        target_handle: props.clicked_product_url,
        source_product_name: base.product_name,
        source_sku: base.sku
      });
    });

    /* *_added_to_cart — PDP add-to-cart success dispatches theme:cartchanged
       with NO detail (assets/theme.js ~3502); cart-line quantity changes carry
       detail and are ignored. Only attributed when the stamped target product
       is the product on this page. */
    document.documentElement.addEventListener('theme:cartchanged', function (e) {
      if (e && e.detail) return;
      var source = readJson(sessionStorage, SOURCE_MODULE_KEY);
      if (!source) return;
      var current = handleFromPath();
      if (source.target_handle && current && source.target_handle !== current) return;
      consumeSourceModule();
      var props = {
        source_product_name: source.source_product_name || '',
        source_sku: source.source_sku || ''
      };
      if (source.module === 'recommendation') track(PDP_EVENTS.recommendation_added_to_cart, props);
      if (source.module === 'view_similar') track(PDP_EVENTS.view_similar_added_to_cart, props);
    });

    /* Store inventory — section VISIBLE in the viewport (QA 2026-10-26: not
       at render time, which landed before "Viewed Product"). The list is
       rendered by updateStoreHTML() (assets/store-locator.js), which
       dispatches storeLocator:storesRendered on every render (variant change,
       location change). Each render (re)arms an IntersectionObserver on the
       list; the event fires once per variant when the list has stayed on
       screen (>=50% of it, or >=240px) for ORDERING_DELAY_MS. */
    var availabilitySeen = {};
    var availabilityObserver = null;
    var availabilityTimer = null;
    function sendStoreAvailability(list, variantId) {
      if (availabilitySeen[variantId]) return;
      availabilitySeen[variantId] = true;
      var boxes = list.querySelectorAll('.store-more-box');
      var inStock = 0;
      boxes.forEach(function (box) {
        if (!box.querySelector('.store-inventory-footer.not-available')) inStock += 1;
      });
      var props = locationProps();
      props.store_count = boxes.length;
      props.in_stock_store_count = inStock;
      props.first_store_name = storeProps(boxes[0]).store_name;
      track(PDP_EVENTS.store_availability_viewed, props);
    }
    function armStoreAvailability() {
      var list = document.querySelector('.ct_more_store_product');
      if (!list || !list.querySelectorAll('.store-more-box').length) return;
      var variantId = baseProps().variant_id || 'default';
      if (availabilitySeen[variantId]) return;
      // A re-render (variant / location change) mid-dwell must not fire for the old list.
      if (availabilityTimer) { window.clearTimeout(availabilityTimer); availabilityTimer = null; }
      if (availabilityObserver) { availabilityObserver.disconnect(); availabilityObserver = null; }
      if (!('IntersectionObserver' in window)) { sendStoreAvailability(list, variantId); return; }
      // QA 2026-11-03/04: fired in the same second as "Viewed Product" on mweb —
      // the single pdp-ds card sits right under the buy buttons and its top edge
      // can peek into the first viewport. A view now means the list stays >=50%
      // visible (or >=240px, one full card, for tall desktop lists) for
      // ORDERING_DELAY_MS continuously. Scrolling past, or an edge peeking in at
      // load, cancels the timer. The dwell also guarantees it lists AFTER
      // "Viewed Product" (pushed at DOM ready).
      availabilityObserver = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (e) {
          return e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= 240);
        });
        if (visible) {
          if (availabilityTimer) return;
          availabilityTimer = window.setTimeout(function () {
            availabilityTimer = null;
            if (availabilityObserver) { availabilityObserver.disconnect(); availabilityObserver = null; }
            sendStoreAvailability(list, variantId);
          }, ORDERING_DELAY_MS);
        } else if (availabilityTimer) {
          window.clearTimeout(availabilityTimer);
          availabilityTimer = null;
        }
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      availabilityObserver.observe(list);
    }
    document.addEventListener('storeLocator:storesRendered', armStoreAvailability);
    // store-locator.js (deferred before this file) renders from the cached
    // location_store synchronously, so its first storesRendered can fire before
    // this listener exists — arm on an already-rendered list too.
    armStoreAvailability();

    /* Store inventory — store action tapped. Pass the selected store.
       QA 2026-11-04: "More Stores" / "View All" are NOT store CTAs here — the
       legacy MoreStores event (store-locator.js ~1171) is the only event for
       that tap, so the mobile .pdp-ds-more link and the .ct-view-all-stores
       link are deliberately absent from the selector. */
    // QA 2026-11-04: a store card's Book / View Appointment button belongs to the
    // appointment funnel only (appointment_cta_clicked below), not to store_inventory.
    var STORE_CTA_SELECTOR = '.ct_store_map, .ct_store_call, .reserve-product';
    document.addEventListener('click', function (e) {
      var cta = closest(e.target, STORE_CTA_SELECTOR);
      if (!cta) return;
      // Only the PDP store module (inline cards + "All stores" popup), not the
      // appointment sheet's own call/map links.
      if (closest(cta, '.appmt-modal, .appmt-modal-location, .appmt-modal-final')) return;
      var action = 'other';
      if (cta.classList.contains('ct_store_map')) action = 'get_directions';
      else if (cta.classList.contains('ct_store_call')) action = 'call_store';
      else if (cta.classList.contains('reserve-product')) action = /view reservation/i.test(text(cta)) ? 'view_reservation' : 'reserve_product';
      var props = storeProps(closest(cta, '.store-more-box'));
      props.action = action;
      props.cta_text = text(cta);
      props.placement = closest(cta, '#ct-all-stores-popup, .ct-all-stores-popup__sheet') ? 'all_stores_popup'
        : closest(cta, '.stInventory-overlay') ? 'reserve_sheet' : 'inline';
      var loc = locationProps();
      props.user_city = loc.user_city;
      track(PDP_EVENTS.store_inventory_cta_clicked, props);
    });

    /* Appointment — "Book appointment" tapped (banner in description, or a
       store card's Book Appointment button). CAPTURE phase so this fires
       before the element's own handler opens the sheet (appointment-modal.js
       binds .appmt-image directly; store buttons use inline onclick) — QA
       wants appointment_cta_clicked listed before appointment_modal_viewed. */
    document.addEventListener('click', function (e) {
      var banner = closest(e.target, '.appmt-image');
      var storeBtn = closest(e.target, '.book-appmt-button');
      if (!banner && !storeBtn) return;
      if (storeBtn && !/book appointment/i.test(text(storeBtn))) return; // "View Appointment" is not a booking CTA
      // Picking a store from the list inside the sheet is appointment_store_selected, not a CTA.
      if (storeBtn && closest(storeBtn, '.appmt-modal, .appmt-modal-location, .appmt-overlay')) return;
      var props = storeBtn ? storeProps(closest(storeBtn, '.store-more-box, .appmt-store-box')) : {};
      props.entry_point = banner ? 'pdp_banner' : 'store_card';
      var loc = locationProps();
      props.user_city = loc.user_city;
      track(PDP_EVENTS.appointment_cta_clicked, props);
    }, true);

    /* Size / Fit — size picked. Listed option buttons are radios inside the
       option wrapper whose class carries the option name
       (snippets/variant-picker.liquid: `ct-filter-type-`). */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.classList.contains('js-option')) return;
      var wrapper = closest(input, '.option-selector');
      if (!wrapper || !/ct-filter-type-Size\b/i.test(wrapper.className)) return;
      var label = wrapper.querySelector('label[for="' + input.id + '"]');
      track(PDP_EVENTS.size_selected, {
        size_value: input.value || text(label),
        option_name: text(wrapper.querySelector('.option-selector__label, .ct_option-selector__label, label.label')) || 'Size',
        // The popup's size <li> re-triggers the main picker radio (snippets/size-guide.liquid
        // ~363), so the input is never inside the popup — check whether the popup is open.
        selection_source: document.querySelector('.ct_size_guide_main.active') ? 'size_chart' : 'pdp'
      });
    });

    /* Size / Fit — size chart opened. Every trigger the PDP exposes. */
    var SIZE_CHART_SELECTOR = '.rb_click_size, .rb_click_size_sec, .rb_size_guide, .ct_size_guide.rb_redirect, .size-chart-link';
    document.addEventListener('click', function (e) {
      var trigger = closest(e.target, SIZE_CHART_SELECTOR);
      if (!trigger) return;
      // snippets/size-guide.liquid chains triggers with jQuery .trigger('click')
      // (.rb_redirect -> .rb_click_size, no-size ATC -> .rb_size_guide). Those
      // synthetic clicks are not a view. The no-size ATC popup OPENING is not a
      // view either (QA 2026-11-03) — only a real tap on "Find your size" inside it.
      if (e.isTrusted === false) return;
      track(PDP_EVENTS.size_chart_viewed, {
        trigger_text: text(trigger),
        trigger_source: 'user'
      });
    });

    /* Size / Fit — add-to-cart blocked, no size.
       Path A (all products): theme.validateProductForm (assets/theme.js ~3317)
       is looked up by name on every submit, so wrapping it here catches the
       generic "Pick a Size" block without touching theme.js.
       Path B (Ring / Kada / Bangle): snippets/size-guide.liquid preventDefaults
       the .show_size_val_btn .btn-with-cart click before any submit, so the
       form validator never runs — listen for that click too. */
    function emptySizeProps(container) {
      var empty = container ? container.querySelector('.option-selector--empty') : null;
      return {
        missing_option: empty
          ? (text(empty.querySelector('.option-selector__label, label')) || 'Size').replace(/^Pick a\s*/i, '')
          : 'Size',
        block_path: ''
      };
    }
    function wrapValidator() {
      if (!window.theme || typeof window.theme.validateProductForm !== 'function' || window.theme.validateProductForm.__kPdpWrapped) return;
      var originalValidate = window.theme.validateProductForm;
      var wrapped = function ($formContainer) {
        var ok = originalValidate.apply(this, arguments);
        if (ok === false) {
          var container = $formContainer && $formContainer[0];
          var props = emptySizeProps(container);
          props.block_path = 'form_validation';
          track(PDP_EVENTS.atc_blocked_no_size, props);
        }
        return ok;
      };
      wrapped.__kPdpWrapped = true;
      window.theme.validateProductForm = wrapped;
    }
    // theme.js is deferred AFTER this file (layout/theme.liquid ~537 vs ~391),
    // so theme.validateProductForm does not exist yet when init() runs.
    // All deferred scripts finish before DOMContentLoaded; wrap there.
    if (document.readyState === 'complete') wrapValidator();
    else document.addEventListener('DOMContentLoaded', wrapValidator);
    window.addEventListener('load', wrapValidator);
    document.addEventListener('click', function (e) {
      var btn = closest(e.target, '.show_size_val_btn .btn-with-cart');
      if (!btn) return;
      var props = emptySizeProps(closest(btn, '.product-form'));
      props.missing_option = 'Size';
      props.block_path = 'size_chart_popup';
      track(PDP_EVENTS.atc_blocked_no_size, props);
      // The size-selection popup opening is NOT a size chart view (QA 2026-11-03).
      // size_chart_viewed fires only on a real tap of "Find your size" inside the
      // popup (.rb_click_size, handled by the delegated click listener above).
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================================
   PDP VIDEO ANALYTICS — K-Reels player (sections/kushals-reel.liquid,
   snippets/k-reel-item.liquid, snippets/k-reels-products.liquid). Events
   sheet rows 23-28, "Webview / PDP".

     video_impression            a reel is >=50% on screen (preview tile on
                                 the page, or the video inside the open
                                 viewer), once per video_id per page load
     video_played                the active reel starts playing, once per
                                 video_id per viewer open; trigger = tap|auto
     video_paused                the user taps the reel to pause it
                                 (programmatic pauses on swipe/close ignored)
     video_completed             playback reaches the end, once per video_id
                                 per viewer open (the <video> loops, so
                                 'ended' never fires — detected on timeupdate)
     video_product_cta_clicked   tap on the product card's button/image/title
     video_added_to_cart         cart add succeeded from the reel (wraps the
                                 player's own window.kReelsCTVideoATC hook)

   video_id = reel key ("k001", …) from the section's [data-reels-json], the
   same id the existing PDP_* reel events use. Uses window.kPdpTrack from the
   block above (same file, already defined), so every event carries the Base
   Payload. Existing reel events (Video Impression, PDP_Video_Open,
   PDP_ATC_From_Video, Product CTA Click, …) are untouched.
   ========================================================================== */
(function () {
  'use strict';

  var VIDEO_EVENTS = {
    video_impression: 'video_impression',
    video_played: 'video_played',
    video_paused: 'video_paused',
    video_completed: 'video_completed',
    video_product_cta_clicked: 'video_product_cta_clicked',
    video_added_to_cart: 'video_added_to_cart'
  };
  if (window.__K_PDP_EVENTS__) {
    for (var k in VIDEO_EVENTS) window.__K_PDP_EVENTS__[k] = VIDEO_EVENTS[k];
  }

  var USER_TAP_WINDOW_MS = 500;
  var COMPLETE_TAIL_S = 0.35;

  function track(name, props) {
    if (typeof window.kPdpTrack === 'function') window.kPdpTrack(name, props);
    else (window.__kPdpTrackQueue = window.__kPdpTrackQueue || []).push([name, props]);
  }
  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }
  function sectionOf(el) { return closest(el, '[id^="k-reels-"]'); }

  var dataCache = [];
  function reelsData(section) {
    if (!section) return [];
    for (var i = 0; i < dataCache.length; i++) if (dataCache[i].section === section) return dataCache[i].data;
    var data = [];
    try {
      var el = section.querySelector('[data-reels-json]');
      data = el ? JSON.parse(el.textContent || '[]') : [];
      if (!Array.isArray(data)) data = [];
    } catch (e) { data = []; }
    dataCache.push({ section: section, data: data });
    return data;
  }
  function productIds(d) {
    var list = d && (d.products || d.product_ids || d.productIds);
    if (!Array.isArray(list)) return '';
    return list.map(function (p) { return p && typeof p === 'object' ? (p.id || p.productId || p.product_id || '') : p; })
      .filter(Boolean).join(',');
  }
  function placementOf(section) {
    var pt = (typeof __st !== 'undefined' && __st && __st.p) || '';
    if (pt === 'product') return 'pdp';
    if (section && section.getAttribute('data-placement')) return section.getAttribute('data-placement');
    return pt === 'index' ? 'home' : 'lp';
  }
  // Identify a reel from a preview tile, a <video>, or any node inside a .k-reel.
  function reelInfo(el) {
    var section = sectionOf(el);
    var data = reelsData(section);
    var index = -1;
    var key = '';
    var tile = closest(el, '.k-prevcard');
    var reel = closest(el, '.k-reel');
    if (tile) {
      key = tile.getAttribute('data-reel-key') || '';
      index = parseInt(tile.getAttribute('data-open-reel'), 10);
    } else if (reel) {
      index = parseInt(reel.getAttribute('data-reel-index'), 10);
    }
    if (isNaN(index)) index = -1;
    // Clones wrap around: -1 is the last reel, reels_count is the first.
    var realIndex = index;
    if (data.length) {
      if (realIndex < 0) realIndex = data.length - 1;
      if (realIndex >= data.length) realIndex = 0;
    }
    var d = data[realIndex] || null;
    if (!key && d && d.key) key = String(d.key);
    return {
      video_id: key,
      video_index: realIndex,
      video_title: d ? String(d.title || '') : '',
      video_product_ids: productIds(d),
      placement: placementOf(section),
      source_component: 'video',
      source_component_id: key
    };
  }
  function activeReelInfo(section) {
    var active = section && (section.querySelector('.k-reel.is-active') || section.querySelector('.k-reel'));
    return active ? reelInfo(active) : reelInfo(section);
  }
  function videoProgress(v) {
    var d = v && isFinite(v.duration) ? v.duration : 0;
    var t = v ? v.currentTime || 0 : 0;
    return {
      position_seconds: Math.round(t * 10) / 10,
      duration_seconds: Math.round(d * 10) / 10,
      progress_pct: d ? Math.min(100, Math.round((t / d) * 100)) : 0,
      muted: !!(v && v.muted)
    };
  }
  function merge(a, b) { var o = {}; var k; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }
  // Reel product prices arrive as Shopify minor units ("1989000" = ₹19,890.00)
  // from .k-pcard[data-price] and the ATC hook; formatted strings ("₹19,890.00")
  // come through other paths. Return rupees as a number either way.
  function rupees(value) {
    var s = String(value == null ? '' : value).trim();
    if (!s) return 0;
    var formatted = /[₹,.\s]/.test(s);
    var n = Number(s.replace(/[^\d.-]/g, ''));
    if (!isFinite(n)) return 0;
    return formatted ? n : n / 100;
  }

  /* --- per-viewer-open state --------------------------------------------- */
  var playedThisOpen = {};
  var completedThisOpen = {};
  var lastTime = {};
  var impressionSeen = {};
  var lastUserTapAt = 0;
  var lastUserTapVideo = null;

  document.addEventListener('kReels:open', function () {
    playedThisOpen = {};
    completedThisOpen = {};
    lastTime = {};
  });

  /* --- video_impression: tiles + viewer videos >= 50% visible -------------- */
  function observeImpressions() {
    var targets = document.querySelectorAll('.k-prevcard[data-reel-key], .k-reel__video');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || e.intersectionRatio < 0.5) return;
        var info = reelInfo(e.target);
        if (!info.video_id || impressionSeen[info.video_id]) return;
        impressionSeen[info.video_id] = true;
        track(VIDEO_EVENTS.video_impression, merge(info, {
          surface: closest(e.target, '.k-prevcard') ? 'preview_tile' : 'viewer'
        }));
      });
    }, { threshold: [0.5] });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* --- user tap on the reel (play/pause toggle lives on .k-reels__track) --- */
  document.addEventListener('click', function (e) {
    var track = closest(e.target, '.k-reels__track');
    if (!track) return;
    if (closest(e.target, '.k-reels__top, .k-reels__right, .k-reels__productwrap, .k-reels-vpop')) return;
    lastUserTapAt = Date.now();
    var reel = closest(e.target, '.k-reel') || track.querySelector('.k-reel.is-active');
    lastUserTapVideo = reel ? reel.querySelector('.k-reel__video') : null;
  }, true);
  function wasUserTap(v) {
    return (Date.now() - lastUserTapAt) <= USER_TAP_WINDOW_MS && (!lastUserTapVideo || lastUserTapVideo === v);
  }

  /* --- play / pause / completed (media events don't bubble: capture) ------ */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || !v.classList || !v.classList.contains('k-reel__video')) return;
    var info = reelInfo(v);
    if (!info.video_id || playedThisOpen[info.video_id]) return;
    playedThisOpen[info.video_id] = true;
    track(VIDEO_EVENTS.video_played, merge(merge(info, videoProgress(v)), {
      trigger: wasUserTap(v) ? 'tap' : 'auto'
    }));
  }, true);

  document.addEventListener('pause', function (e) {
    var v = e.target;
    if (!v || !v.classList || !v.classList.contains('k-reel__video')) return;
    if (!wasUserTap(v)) return; // swipe/close/settle pauses are not user pauses
    var info = reelInfo(v);
    if (!info.video_id) return;
    track(VIDEO_EVENTS.video_paused, merge(info, videoProgress(v)));
  }, true);

  document.addEventListener('timeupdate', function (e) {
    var v = e.target;
    if (!v || !v.classList || !v.classList.contains('k-reel__video')) return;
    var d = isFinite(v.duration) ? v.duration : 0;
    if (!d) return;
    var info = reelInfo(v);
    var id = info.video_id;
    if (!id) return;
    var t = v.currentTime || 0;
    var prev = lastTime[id] || 0;
    lastTime[id] = t;
    if (completedThisOpen[id]) return;
    // Reached the tail, or the loop wrapped back to the start from near the end.
    var reachedEnd = t >= d - COMPLETE_TAIL_S;
    var wrapped = prev > d * 0.8 && t < prev - 1;
    if (!reachedEnd && !wrapped) return;
    completedThisOpen[id] = true;
    track(VIDEO_EVENTS.video_completed, merge(info, {
      duration_seconds: Math.round(d * 10) / 10,
      muted: !!v.muted
    }));
  }, true);

  /* --- product CTA on the reel ------------------------------------------- */
  document.addEventListener('click', function (e) {
    var cta = closest(e.target, '.k-reels__productwrap .k-patc, .k-reels__productwrap .k-pimg, .k-reels__productwrap .k-ptitle');
    if (!cta) return;
    var card = closest(cta, '.k-pcard');
    var section = sectionOf(cta);
    var info = activeReelInfo(section);
    track(VIDEO_EVENTS.video_product_cta_clicked, merge(info, {
      cta_type: cta.classList.contains('k-patc') ? 'add_to_cart' : 'product_link',
      cta_text: String(cta.textContent || '').trim().slice(0, 60),
      clicked_product_id: card ? (card.getAttribute('data-product-id') || '') : '',
      clicked_variant_id: card ? (card.getAttribute('data-variant') || '') : '',
      clicked_product_name: card ? (card.getAttribute('data-title') || '') : '',
      clicked_product_price: card ? rupees(card.getAttribute('data-price')) : 0,
      is_crosssell: !!(card && card.getAttribute('data-crosssell') === 'true')
    }));
  }, true);

  /* --- added to cart: wrap the player's own success hook ------------------ */
  // kushals-reel.liquid assigns window.kReelsCTVideoATC from an inline script
  // (parse time, before this deferred file) and every ATC path — single
  // variant (snippets/k-reels-products.liquid) and the variant popup
  // (assets/variant-popup.js) — calls it on success. Wrap whatever is there
  // now and whatever a later section assigns.
  function wrapAtc(fn) {
    if (typeof fn !== 'function' || fn.__kVideoWrapped) return fn;
    var wrapped = function (params) {
      var result;
      try { result = fn.apply(this, arguments); } catch (e) {}
      try {
        var p = params || {};
        var section = document.querySelector('.k-reels__modal:not([hidden])') ? sectionOf(document.querySelector('.k-reels__modal:not([hidden])')) : null;
        var info = section ? activeReelInfo(section) : {};
        if (p.video_id) { info.video_id = String(p.video_id); info.source_component_id = String(p.video_id); }
        info.source_component = 'video';
        track(VIDEO_EVENTS.video_added_to_cart, merge(info, {
          product_id: String(p.product_id || p.productId || ''),
          variant_id_added: String(p.variant_id || p.variantId || ''),
          added_product_name: String(p.product_title || p.productTitle || p.product_name || p.title || ''),
          added_product_sku: String(p.product_sku || p.productSku || p.sku || ''),
          added_product_price: rupees(p.product_price || p.productPrice || p.price),
          is_crosssell: !!p.is_crosssell
        }));
      } catch (e) {}
      return result;
    };
    wrapped.__kVideoWrapped = true;
    return wrapped;
  }
  (function trapAtcHook() {
    var current = wrapAtc(window.kReelsCTVideoATC);
    try {
      Object.defineProperty(window, 'kReelsCTVideoATC', {
        configurable: true,
        enumerable: true,
        get: function () { return current; },
        set: function (fn) { current = wrapAtc(fn); }
      });
    } catch (e) {
      window.kReelsCTVideoATC = current;
    }
  })();

  function init() {
    if (!document.querySelector('[id^="k-reels-"]')) return;
    observeImpressions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
